"use client";
import { useMutation } from "@stadium/services/apollo-client";

import { MODIFY_USER } from "@stadium/hooks/graphql/mutations/user/modify";

const useModifyUser = (successCallback) => {
  const [modifyUser, { loading, error }] = useMutation(MODIFY_USER, {
    onCompleted: () => {
      successCallback?.();
    },
  });

  return {
    modifyUser,
    loading,
    error,
  };
};

export default useModifyUser;
